<template>
  <v-form ref="onlinePayAccountEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'online-pay-account-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование аккаунта' : 'Создание аккаунта'}}</h1>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-text-field
            v-model="onlinePayAccount.name"
            label="Название"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-radio-group
            class="mb-4 ml-4"
            v-model="onlinePayAccount.type"
            row
        >
          <v-radio
              label="Liqpay"
              value="liqpay"
          ></v-radio>
          <v-radio
              label="Wayforpay"
              value="wayforpay"
          ></v-radio>
        </v-radio-group>
        <v-text-field
            v-model="onlinePayAccount.app_key"
            label="Ключ для приложения"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-text-field
            v-model="onlinePayAccount.public_key"
            label="Public key"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-text-field
            v-model="onlinePayAccount.private_key"
            label="Private key"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-text-field
            v-model="onlinePayAccount.merchant_id"
            label="Merchant id"
            required
            outlined
        ></v-text-field>
        <v-file-input
            v-model="certificate"
            label="File input"
        ></v-file-input>
        <v-checkbox
            dense
            hide-details
            v-model="onlinePayAccount.is_fiscalization"
            label="Фискализировать"
            class="mb-5"
        >
        </v-checkbox>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import OnlinePayAccountService from './../../api/OnlinePayAccountService'

  export default {
    name: 'OnlinePayAccountEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      certificate: null,
      onlinePayAccount: {
        name: '',
        type: '',
        app_key: '',
        public_key: '',
        private_key: '',
        is_fiscalization: false,
        certificate: null,
        merchant_id: ''
      },
      loading: true,
      loadingButton: false,
    }),
    mounted() {
        if(this.id) {
            OnlinePayAccountService.get(this.id)
                .then(response => {
                    this.onlinePayAccount = response.data;
                    this.loading = false
                });
        }
    },
    methods: {
      validate() {
        this.$refs.onlinePayAccountEditForm.validate()

      },

      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        OnlinePayAccountService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Успешно обновлено';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        OnlinePayAccountService.create(formData).then(response => {
            this.$router.push({ name: 'online-pay-account-edit', params: { id: response.data.id } })
          this.onlinePayAccount.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Аккаунт создан';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('id', this.id);
          formData.append('name', this.onlinePayAccount.name);
          formData.append('type', this.onlinePayAccount.type);
          formData.append('app_key', this.onlinePayAccount.app_key);
          formData.append('public_key', this.onlinePayAccount.public_key);
          formData.append('private_key', this.onlinePayAccount.private_key);
          if(this.certificate && !this.certificate.url) {
            formData.append('certificate', this.certificate);
          }
        formData.append('merchant_id', this.onlinePayAccount.merchant_id);
        formData.append('is_fiscalization', this.onlinePayAccount.is_fiscalization ? 1 : 0);
          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .onlinePayAccount-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .onlinePayAccount{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
